import { API_STATUS } from "../../../constants/apiStatus";

export const usersSliceInitialState = {
  users: [],
  selectedUser: null,
  apiStatus: {
    getUsers: API_STATUS.IDLE,
    getUserById: API_STATUS.IDLE,
    createUser: API_STATUS.IDLE,
    updateUser: API_STATUS.IDLE,
    deleteUser: API_STATUS.IDLE,
  },
  pagination: {
    enabled: true, // will be set to false after first fetch with new API
    currentPage: 1,
    totalPages: 1,
    totalUsers: 0,
    limit: 10,
  },
  error: null,
};
